module.exports = __webpack_public_path__ + "img/ops.598fc6e1.png";